/**
 * Created by jv on 10/02/2021.
 */
import "cookieconsent/build/cookieconsent.min.css";
import "cookieconsent";

import log from "@/utils/logger";

export default {
    install: (app) =>
    {
        function initialiseCookieConsent()
        {
            window.cookieconsent.initialise({
                palette: {
                    popup: {
                        background: "#222222",
                        text: "#ffffff"
                    },
                    button: {
                        background: "#016FB7",
                        text: "#ffffff"
                    }
                },
                theme: "classic",
                type: "opt-in",
                content: {
                    message: "beweegbuddy.be gebruikt cookies om je browserervaring te verbeteren en te beveiligen.",
                    deny: "Enkel noodzakelijke",
                    allow: "Ik ga akkoord",
                    link: "Meer informatie",
                    href: "/legal#cookie-policy"
                },
                revokable: false,
                law: {
                    regionalLaw: false
                },
                cookie: {
                    expiryDays: 365
                },
                onStatusChange: function(status)
                {
                    if (status === "allow")
                    {
                        onConsented();
                    }
                    else
                    {
                        onDeclined();
                    }
                }
            });
        }

        function onConsented()
        {
            log.debug("User consented to cookies");
            app.config.globalProperties.$gtag.optIn();
        }

        function onDeclined()
        {
            log.debug("User declined cookies");
            app.config.globalProperties.$gtag.optOut();
        }

        app.config.globalProperties.$initialiseCookieConsent = initialiseCookieConsent;
        app.provide("initialiseCookieConsent", initialiseCookieConsent);
    }
};
